import { useEffect } from "react";

import { trackPortalEvent } from "../utils/analytics";

const SCROLL_THRESHOLDS = [25, 50, 75, 90];

const getScrollPercent = () => {
  const doc = document.documentElement;
  const scrollableHeight = doc.scrollHeight - window.innerHeight;
  if (scrollableHeight <= 0) return 100;

  return Math.round((window.scrollY / scrollableHeight) * 100);
};

const useReportAnalytics = (enabled) => {
  useEffect(() => {
    if (
      !enabled ||
      typeof window === "undefined" ||
      typeof document === "undefined" ||
      typeof IntersectionObserver === "undefined"
    ) {
      return undefined;
    }

    const seenSections = new Set();
    const sentDepths = new Set();

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          const section = entry.target.getAttribute("data-report-section");
          if (!section || seenSections.has(section)) return;

          seenSections.add(section);
          trackPortalEvent("ReportSectionView", { section });
        });
      },
      { threshold: 0.55 }
    );

    document.querySelectorAll("[data-report-section]").forEach((element) => {
      observer.observe(element);
    });

    const handleScroll = () => {
      const scrollPercent = getScrollPercent();
      SCROLL_THRESHOLDS.forEach((depth) => {
        if (scrollPercent >= depth && !sentDepths.has(depth)) {
          sentDepths.add(depth);
          trackPortalEvent("ReportScrollDepth", { depth });
        }
      });
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      observer.disconnect();
      window.removeEventListener("scroll", handleScroll);
    };
  }, [enabled]);
};

export default useReportAnalytics;
